import { combineReducers } from "redux";
import blogReducer from "./blogs/blogReducer";
import filterReducer from "./filters/filterReducer";

const rootReducer = combineReducers({
    blog: blogReducer,
    filter: filterReducer,
});

export default rootReducer;
